// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3BFJX","buttons":"RemoveExpirationActionButtons_buttons__3ls_l"};